import { render, staticRenderFns } from "./ViewOrders.vue?vue&type=template&id=9f7bf644&scoped=true"
import script from "./ViewOrders.vue?vue&type=script&lang=js"
export * from "./ViewOrders.vue?vue&type=script&lang=js"
import style0 from "./ViewOrders.vue?vue&type=style&index=0&id=9f7bf644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7bf644",
  null
  
)

export default component.exports